import type { Position } from '@modules/advancement/duck/types';

export function isSubUnitPosition(position: Position) {
  return Boolean(position.denId || position.patrolId || position.denNumber);
}
